/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPlacesHttpService } from '../../core/services';

export class GeofenceClientIdValidator {
  static createValidator(placesHttpService: IPlacesHttpService, initialValueId: string): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors> =>
      (control.value as string)?.trim() === '' || (control.value as string)?.trim() === initialValueId
        ? of(null)
        : placesHttpService
            .validatePlaceClientId(control.value)
            .pipe(map(response => (response === false ? { invalidClientId: true } : null)));
  }
}
